module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("3EFF2"))).then(() => parcelRequire('1iHdE'));